import React from "react";

const FeaturePageLayout = ({ title, caption, imageUrl }) => {
  return (
    <div className="min-h-screen bg-blue-50 flex items-center justify-center px-6 py-12 font-sans">
      <div className="w-full max-w-6xl bg-white/80 backdrop-blur-lg shadow-2xl rounded-3xl overflow-hidden flex flex-col lg:flex-row border border-blue-100 transition duration-300">
        <div className="lg:w-1/2 w-full">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="lg:w-1/2 p-10 flex flex-col justify-center text-left">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">{title}</h1>
          <p className="text-lg text-gray-600 leading-relaxed">{caption}</p>
        </div>
      </div>
    </div>
  );
};

export default FeaturePageLayout;